export const getApproxAge = (age: string): string => {
  if (age.includes('-') && !age.toLocaleLowerCase().includes('years')){
    return age + ' years';
  }
  return age;
};